export * from '@fhs/routing/src/routes/store-locator/index';
export { default } from '@fhs/routing/src/routes/store-locator/index';
